module.exports = __webpack_public_path__ + "img/BRCA1_Myofibroblasts.7fd4c3f0.png";